import { render, staticRenderFns } from "./skeleton-loader.vue?vue&type=template&id=4dfdc138&scoped=true&"
import script from "./skeleton-loader.vue?vue&type=script&lang=js&"
export * from "./skeleton-loader.vue?vue&type=script&lang=js&"
import style0 from "./skeleton-loader.vue?vue&type=style&index=0&id=4dfdc138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfdc138",
  null
  
)

export default component.exports